import moduleConfig from './module-config';
import netsContactDetails from './nets-contact-details';

export default angular
  .module('app.contact-details', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsContactDetails', netsContactDetails);
